import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatLaunchTime } from '../../../_shared/helpers/formatting';
import WatchListButton from '../../WatchlistButton';
import {
  context,
  TradeState,
  TradeViewVariant
} from '../../../_shared/types/trade';
import useWatchlist from '../../../_shared/hooks/useWatchlist';
import Icon from '../../../_shared/components/Icon';
import { BidSource } from '../../../_shared/types/auction';
import ROUTES from '../../Routes/constants';

import { CtaContainer, ShareRetailButton, StyledHeader } from './Styles';

const Header = ({
  isWatchlisted,
  onRetailVDPOpen,
  statusDates,
  tradeId,
  tradeDetails,
  tradeContext,
  tradeState,
  isOMP
}) => {
  const [watchList, setWatchList] = useWatchlist(
    tradeId,
    tradeState,
    isWatchlisted
  );

  const {
    auctionSummary,
    vin,
    year,
    manufacturerName,
    modelName,
    trim,
    isAsIs,
    transportInfo,
    dealer,
    tradeFloorPrice,
    network
  } = tradeDetails;

  const { id: launchId, values: launchValues } = formatLaunchTime(
    tradeState,
    statusDates,
    TradeViewVariant.VDP
  );

  const pageSource = window.location.href.includes(ROUTES.BUYING)
    ? BidSource.MINI_VDP
    : BidSource.VDP_OVERLAY;

  const isBuying = tradeContext === context.buying;
  const showShare = isBuying;
  const showWatchlist =
    typeof isWatchlisted === 'boolean' &&
    isBuying &&
    [TradeState.upcoming, TradeState.active].includes(tradeState);

  return (
    <StyledHeader data-testid="vdp-header">
      <CtaContainer className="notranslate">
        {launchId && launchValues && tradeId === tradeDetails?.id && (
          <FormattedMessage id={launchId} values={launchValues} />
        )}
      </CtaContainer>
      <CtaContainer>
        {showShare && (
          <ShareRetailButton
            onClick={onRetailVDPOpen}
            addMargin={showWatchlist}
            data-testid="vdp-share-retail-button"
          >
            <Icon icon="TR5-Share" />
            <FormattedMessage id="vdp.share" />
          </ShareRetailButton>
        )}
        {showWatchlist && (
          <WatchListButton
            auctionId={auctionSummary?.id}
            dateExpected={dealer?.dateExpected}
            dealershipId={dealer?.id}
            dealershipName={transportInfo?.displayName}
            isAsIs={isAsIs}
            isWatchlisted={watchList}
            manufacturerName={manufacturerName}
            modelName={modelName}
            pageSource={pageSource}
            tradeId={tradeId}
            tradeState={tradeState}
            trim={trim}
            variant="fullsize"
            vin={vin}
            year={year}
            setParentWatchList={setWatchList}
            isOMP={isOMP}
            tradeFloorPrice={tradeFloorPrice}
            networkName={network?.displayName}
            isInSaleEvent={!!tradeDetails?.saleEventId}
          />
        )}
      </CtaContainer>
    </StyledHeader>
  );
};

export default Header;
